import {
  IOrganization,
  IOrganizationAddress,
  IOrganizationAuthorization,
  IOrganizationIdentifier, IOrganizationPhoto,
  IOrganizationTelecom, IOrganizationType, IClientGenericIntegrationMap
} from '../interfaces';
import { IMeta } from '@ispm/core/interfaces/meta.interface';

export class OrganizationEntity implements IOrganization {
  id: string;
  name: string;
  displayName: string;
  active?: boolean;
  account_id?: string;
  address?: IOrganizationAddress[];
  alias?: Array<string>;
  authorization?: IOrganizationAuthorization[];
  billing?: string;
  billingAccountNumber?: string;
  clarity?: {
    api?: {
      host?: string;
      path?: string;
      pathUdf?: string;
      pathSample?: string;
      pathProject?: string;
      pathRouting?: string;
      pathArtifact?: string;
      pathWorkflow?: string;
      pathContainer?: string;
      pathResearcher?: string;
      pathContainerType?: string
    };
    sample?: {
      locValue?: string
    };
    project?: {
      baseUri?: string;
      dateFormat?: string
    };
    artifact?: {
      baseUri?: string
    };
    password?: string;
    specimen?: {
      initialStatus?: string;
      errorAccessionStatus?: string
    };
    username?: string;
    container?: {
      name?: string;
      baseUri?: string;
      typeUri?: string
    };
    namespace?: {
      udf?: string;
      sample?: string;
      project?: string;
      routing?: string;
      container?: string
    };
    researcher?: {
      uri?: string;
      lastName?: string;
      firstName?: string
    };
    primaryStage?: string;
    successStatus?: string;
    primaryTumorField?: string
  };
  clientGenericIntegrationMap?: IClientGenericIntegrationMap;
  contact?: Array<string>;
  contact_id?: string;
  context?: Array<string>;
  curationWorklistLabel?: string;
  disableWorklist?: boolean;
  enableCuration?: boolean;
  language?: {
    code: string;
    display: string;
  };
  errorEmail?: {
    cc?: string;
    to?: string;
    bcc?: string;
    templateName?: string;
  };
  externalId?: string;
  forms?: {
    PATIENT_CONTACT_INFO?: {
      formId?: string
    };
    PATIENT_BASIC_INFO?: {
      formId?: string
    }
  };
  generateHtmlReport?: boolean;
  identifier?: IOrganizationIdentifier[];
  iob?: {
    ssl?: {
      keyAlias?: string;
      keyPassword?: string;
      keyStoreData?: string;
      keyStoreType?: string;
      keyStorePassword?: string
    };
    url?: string
  };
  logo?: string;
  meta?: IMeta;
  nof1?: {
    profile?: {
      code?: string
      display?: string
    }
  };
  partOf?: {
    reference?: string;
    display?: string;
  };
  permissions?: {
    AllowSendToCurationUserList?: string
  };
  photo?: IOrganizationPhoto[];
  qms?: {
    root?: string;
    report_id?: string
  };
  reportRepositoryEndpoint?: string;
  reportStorageId?: string;
  resourceType?: string;
  salesforce?: {
    loginUrl?: string;
    orderUrl?: string;
    accountId?: string;
    failureEmail?: string;
    loginClientId?: string;
    loginPassword?: string;
    loginUsername?: string;
    loginClientSecret?: string
  };
  private sapid?: string;
  SAPId?: string;
  supervisor?: string;
  telecom?: IOrganizationTelecom[];
  testElapsedTime?: string;
  twoFaEnabled?: boolean;
  type?: IOrganizationType;
  iamOrgId?: string;
  iamFoundationOrg?: boolean;

  constructor(init?: Partial<OrganizationEntity>) {
    Object.assign(this, init);

    // in Node we use SAPId name instead of sapeid, sapeid - is wrong!!!
    if (this.sapid) {
      this.SAPId = this.sapid;
    }
  }
}
